import React from 'react';
import { connect } from 'react-redux';

import { pullCampaignOffices, pullCampaigns } from '../../../store/api/calls';
import {
  setFocusedCampaign,
  clearSiteCanvassCache,
  clearCampaignCanvassersCache,
  clearCampaignSitesCache,
  clearCampaignOfficeCache,
  clearCampaignAggCache,
  setDashboardParams,
} from '../../../store/actions';

class CampaignSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // pullCampaignOffices()

    if (!this.props.campaigns.length) {
      pullCampaigns();
    }
  }

  mapPermissionsGroups() {
    let groups = [];

    if (!this.props.permissions_groups) return groups;

    this.props.permissions_groups.forEach((item) => {
      groups.push(item.id);
    });

    return groups;
  }

  filterOptionsByPermission() {
    if (!this.props.permissions_groups) return [];

    let result = [];
    let admin = this.props.permissions_groups.find((item) => item.name === 'admin');
    let root = this.props.permissions_groups.find((item) => item.name === 'root');

    if (admin || root) return this.props.campaigns;

    let groups = this.mapPermissionsGroups();
    if (!this.props.campaigns) return result;

    this.props.campaigns.forEach((campaign) => {
      if (groups.includes(campaign.auth_group_id)) {
        result.push(campaign);
      }
    });

    return result;
  }

  renderOptions() {
    let campaigns = this.filterOptionsByPermission();

    let options = campaigns.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name}
      </option>
    ));

    return options;
  }

  handleChange = (ev) => {
    const value = ev.target.value;
    this.props.clearCampaignAggCache();
    this.props.clearSiteCanvassCache();
    this.props.clearCampaignCanvassersCache();
    this.props.clearCampaignSitesCache();
    this.props.clearCampaignOfficeCache();
    this.props.setFocusedCampaign(+value);
    this.props.clearSelectedOffice();
    pullCampaignOffices();
  };

  render() {
    return (
      <select
        id="campaign-select"
        className={this.props.disabled ? 'disabled' : ''}
        value={this.props.focusedCampaign.id}
        onChange={this.handleChange}
        style={{ width: '300px' }}
      >
        {this.renderOptions()}
      </select>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  permissions_groups: state.permissions.groups,
});

const mapDispatchToProps = (dispatch) => ({
  setFocusedCampaign: (campaign_id) => dispatch(setFocusedCampaign(campaign_id)),
  clearSiteCanvassCache: () => dispatch(clearSiteCanvassCache()),
  clearCampaignCanvassersCache: () => dispatch(clearCampaignCanvassersCache()),
  clearCampaignSitesCache: () => dispatch(clearCampaignSitesCache()),
  clearCampaignOfficeCache: () => dispatch(clearCampaignOfficeCache()),
  clearCampaignAggCache: () => dispatch(clearCampaignAggCache()),
  clearSelectedOffice: () =>
    dispatch(setDashboardParams({ selectedOffice: null, selectedScript: 0 })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignSelector);
